import script from "./FileView.vue?vue&type=script&setup=true&lang=js"
export * from "./FileView.vue?vue&type=script&setup=true&lang=js"

import "./FileView.vue?vue&type=style&index=0&id=e87f5e74&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e87f5e74"]])

export default __exports__